import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData } from '../Services/api';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const POTypeList = () => {
    const [poTypes, setPOTypes] = useState([]);

    const fetchTypes = async () => {
        try {
            const res = await getData('/po-types');
            if (res.status) {
                setPOTypes(res.data || [])
            }
        } catch (error) {
            console.log("error fetch po types", error)
        }
    }

    useEffect(() => {
        fetchTypes();
    }, []);

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/po-types/delete/${id}`);
                    if (res.status) {
                        toast.success(res.message);
                        fetchTypes();
                    }
                } catch (error) {
                    console.log("error delete po type", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/po-types/po-type-list">PO Types</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            PO Types
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">PO Types</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="text-end p-4 pb-sm-2">
                                    <Link to="/po-types/add-po-type"
                                        className="btn btn-primary d-inline-flex align-item-center"
                                    >
                                        <i className="fas fa-plus f-18 mx-2" /> Add PO Type
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Type Name</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    poTypes?.length > 0 ? (
                                                        poTypes?.map((type, index) => {
                                                            return (
                                                                <tr key={type.id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <h6 className="mb-0">{type.type_name}</h6>
                                                                    </td>
                                                                    <td>
                                                                        <span className={`badge ${type.is_active ? 'bg-success' : 'bg-danger'}`}>
                                                                            {type.is_active ? 'Active' : 'Inactive'}
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/po-types/update-po-type/${type.id}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Delete"
                                                                            >
                                                                                <button
                                                                                    onClick={() => handleDelete(type.id)}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td className='text-center' colSpan={4}><strong>No Data Found.</strong></td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default POTypeList
